export const MINIMUM_IDEAL_CHARGE = 50; // 0.5 EUR
export const REDIRECT_IDEAL_URL = '/purchase/pending';
export const MINIMUM_IDEAL_NAME_LENGTH = 3;
export const IDEAL_ICON = require('static/img/payment-types/ideal.png');
